import * as React from "react";
import { Helmet } from "react-helmet";

export default function RobotsNoIndex() {
	return (
		<Helmet>
			<meta name="robots" content="noindex" />
		</Helmet>
	);
}
